// @flow

import React, { useEffect } from 'react';

import type { DispatchProps, OwnProps } from '../container/BaseRouteHandlerContainer';

const BaseRouteHandler = (props: DispatchProps & OwnProps) => {
  useEffect(() => {
    props.displayGeneralSearch(props.includeSearch);
    props.displayCollectionsFooter(props.includeFooter);
  }, []);

  useEffect(() => {
    if (document.body) document.body.scrollTop = 0;
  }, []);

  return <div>{props.children}</div>;
};

export default BaseRouteHandler;
